import { parsePaddingString } from '../../common-utils';
import { safeParse } from '../../common-utils/math';
import { copy } from '../../common-utils';
import { NodeLike } from '../context/node';

/**
 * Get padding of the node.
 * The priority is
 *  individual side properties > padding object > padding string/number > default 0
 * @param node
 * @returns
 */
export function getPaddingBox(node) {
  const paddingObj = node.padding;
  let pt = 0,
    pr = 0,
    pb = 0,
    pl = 0;

  if (typeof paddingObj === 'object' && paddingObj !== null) {
    pt = paddingObj.top ?? 0;
    pr = paddingObj.right ?? 0;
    pb = paddingObj.bottom ?? 0;
    pl = paddingObj.left ?? 0;
  } else if (typeof paddingObj === 'string' || typeof paddingObj === 'number') {
    [pt, pr, pb, pl] = parsePaddingString(paddingObj);
  }

  const left = safeParse(node.paddingLeft ?? pl);
  const right = safeParse(node.paddingRight ?? pr);
  const top = safeParse(node.paddingTop ?? pt);
  const bottom = safeParse(node.paddingBottom ?? pb);

  return {
    top,
    bottom,
    left,
    right,
    x: left + right,
    y: top + bottom,
  };
}

function removeHiddenProps(node, readed?: Set<unknown>) {
  if (!(node instanceof Object)) return node;
  readed = readed || new Set();
  if (readed.has(node)) {
    throw `readed: ${node}`;
  }
  readed.add(node);
  const newNode = { ...node };
  Object.keys(newNode).forEach((key) => {
    if (key.startsWith('_')) {
      delete newNode[key];
    } else if (newNode[key] instanceof Object) {
      if (Array.isArray(newNode[key])) {
        newNode[key] = newNode[key].map((item) => removeHiddenProps(item, readed));
      } else {
        newNode[key] = removeHiddenProps(newNode[key], readed);
      }
    }
  });
  return newNode;
}

function removeNodes(originNodes) {
  const nodes = {};
  if (!originNodes) return nodes;
  Object.keys(originNodes).map((id) => {
    nodes[id] = removeHiddenProps(originNodes[id]);
  });
  return nodes;
}

export function templateCopy(input) {
  const template = copy(input);
  delete template.props.input;
  return Object.assign({}, template, {
    props: {
      ...template.props,
      nodes: removeNodes(template.props.nodes),
    },
  });
}

export function sortByIndex(a: NodeLike, b: NodeLike) {
  if (a.index < b.index) {
    return -1;
  }
  if (a.index > b.index) {
    return 1;
  }
  return 0;
}

export function createId() {
  return Math.random().toString(36).substr(2, 9);
}
